export const theme = {
  logoImg: {
    display: 'block',
    height: '100%',
  },
};
